import { isMockEnabled } from "@/lib/mock-flags";
import { sseClient } from "./sse-client";
import { mockNotificationsClient } from "./sse-mock";
import type { NotificationsClient } from "./types";

/** Cliente ativo escolhido pela flag VITE_MOCK_NOTIFICATIONS. */
export function getNotificationsClient(): NotificationsClient {
  // isMockEnabled é um getter de flag — não é um hook React. Mesmo padrão dos
  // outros features/api/index.ts deste repo.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return isMockEnabled("notifications") ? mockNotificationsClient : sseClient;
}

export type { NotificationsClient } from "./types";
